<ng-template #groupFieldsTemplate let-width="width">
  <div *ngFor="let prop of formattedFormFields.form_fields">
    <div [ngSwitch]="prop.field_component">
      <check-box
        *ngSwitchCase="'check'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></check-box>
      <radio-button
        *ngSwitchCase="'radio'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></radio-button>
      <select-box
        *ngSwitchCase="'select'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></select-box>
      <text-box
        *ngSwitchDefault
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></text-box>
      <date-picker
        *ngSwitchCase="'date'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></date-picker>
      <text-view
        *ngSwitchCase="'text-view'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></text-view>
      <text-view-bp
        *ngSwitchCase="'textviewbp'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></text-view-bp>
      <group-fields
        *ngSwitchCase="'groupfields'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></group-fields>
      <text-view-area
        *ngSwitchCase="'textviewarea'"
        [prop]="prop"
        [graphicFormGroup]="graphicFormGroup"
        [detailFormDataModel]="detailFormDataModel"
      ></text-view-area>
    </div>
  </div>
</ng-template>

<div>
  <div class="card">
    <!--- the card header -->
    <div class="card-header">
      <div class="row">
        <div class="col-md-12">
          {{ prop.field_label | translate }}
        </div>
      </div>
    </div>
    <!-- the card body -->
    <div class="card-body">
      <ng-container
        *ngTemplateOutlet="
          groupFieldsTemplate;
          context: { formFields: formattedFormFields.form_fields, width: 'col-12' }
        "
      >
      </ng-container>
    </div>
  </div>
</div>
